// extracted by mini-css-extract-plugin
module.exports = {"Input":"UserInput_Input__37Ge6","InputElement":"UserInput_InputElement__3wYlj","Invalid":"UserInput_Invalid__2v7MT"};